<template>
  <div class="a-accordion__tab" :style="{'margin-left': (40 * item.level) + 'px'}">
    <div class="a-accordion__btn-tab ">
      <div class="a-accordion__label" @click="onToggleLevel">
        <img src="@/assets/img/static/arrow-vector.png" v-if="item.hasChild">
        <span>{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NomenclatureCatalogLevel',

    props: {
      item: Object
    },

    methods: {
      async onToggleLevel() {
        try {
          await this.$store.dispatch('toggleNomenclatureItem', this.item);
        }
        catch(e) {
        }
      }
    }
  }
</script>

<style scoped>

</style>
